// @flow

import React from 'react';

import MenuItemDropdown, { MenuItemLink } from './MenuItem';
import MenuList from './MenuList';

import config from 'appconfig';

export default () => (
  <MenuList>
    <MenuItemDropdown menuKey="products" text="navigation.header.products" />
    <MenuItemDropdown menuKey="teams" text="navigation.header.teams" />
    <MenuItemDropdown menuKey="support" text="navigation.header.support" />
    <MenuItemLink href={`${config.wacUrl}/try`} text="navigation.header.try" />
    <MenuItemLink href={`${config.root}`} text="navigation.header.buy" />
  </MenuList>
);
